import React from "react";
import theme from '../../theme';
import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { Box } from '@mui/material/';
import { ThemeProvider } from '@mui/material/styles';
import { checkLoginEnabled } from "../../app/util";
import { AtuoLogoutTimer } from '../AutoLogoutTimer';
import { GRACE_TIME, TIME_OUT } from "../../app/config-v4-api";

// TODO: replace with the final hosted PDF URL when available
const GUIDE_PDF_URL = "https://com-lodgiq-rm-v4-template.s3.us-east-1.amazonaws.com/LodgIQ_User_guide/LodgIQ_Onboarding_Handbook.pdf";

// toolbar=0/navpanes=0 hide the browser's native PDF toolbar (print, download,
// rotate, its own zoom controls, etc.). Zoom is still available to users via the
// browser's own Ctrl+scroll / Ctrl+Plus-Minus / pinch-zoom.
const PDF_SRC = `${GUIDE_PDF_URL}#toolbar=0&navpanes=0`;

const LodgiqUserGuideDashboard = () => {
  if (!checkLoginEnabled()) {
    localStorage.clear();
    sessionStorage.clear();
    window.top.location.href = '/login';
  }

  return (
    <AtuoLogoutTimer timeout={TIME_OUT} graceTime={GRACE_TIME}>
      <ThemeProvider theme={theme}>
        <Box>
          <Header />
        </Box>

        <Box
          sx={{
            height: "100%",
            background: "#f3f3f3",
            boxSizing: "border-box",
            pt: "50px", // matches .app-top-bar height (Header/styles.scss)
            pb: "32px", // matches .container-control height (index.scss)
            "@media (min-width:1400px)": { pb: "30px" },
            "@media (min-width:1600px)": { pb: "32px" },
            "@media (min-width:1800px)": { pb: "34px" },
            "@media (min-width:2500px)": { pt: "55px" },
          }}
        >
          <iframe title="LodgIQ User Guide" src={PDF_SRC} style={{ display: "block", width: "100%", height: "100%", border: "none" }} />
        </Box>

        <Box>
          <DashboardFooter />
        </Box>
      </ThemeProvider>
    </AtuoLogoutTimer>
  );
};

export default LodgiqUserGuideDashboard;
